import { takeLatest } from 'redux-saga'
import { call } from 'redux-saga/effects'

import chameleon from 'helpers/chameleon'
import actionTypes from 'redux/actions/actionTypes'

function *trackOnboardingGuideLaunchTourCard() {
	try {
		yield call(chameleon.track, 'Click Launch Tour Card')
	} catch (error) {
		// console.log(error)
	}
}

export default [
	takeLatest(actionTypes.ONBOARDING_GUIDE_LAUNCH_TOUR_CARD_SUCCESS, trackOnboardingGuideLaunchTourCard),
]

export {
	trackOnboardingGuideLaunchTourCard,
}
